__turbopack_context__.v({
  "ButtonListBlock": "_490dxG_ButtonListBlock",
  "ButtonListBlock__inner": "_490dxG_ButtonListBlock__inner",
  "text-center": "_490dxG_text-center",
  "text-left": "_490dxG_text-left",
  "text-right": "_490dxG_text-right",
});
